import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Whale } from '../../common/icons';

const WithdrawSummaryLayout = () => {
	const { t } = useTranslation();

	useEffect(() => {
		setTimeout(() => {
			window.close();
		}, 3000);
	}, []);

	return (
		<>
			<div className={'component'}>
				<div className={'innerComponent'}>
					<Whale className={'redirectWhale'} />
					<h1 className={'redirectHeaderText'}>
						{t(
							sessionStorage.getItem('operationStatus') ===
								'success'
								? 'withdrawSummarySuccessHeader'
								: 'withdrawSummaryFailureHeader'
						)}
					</h1>
					<h1 className={'withdrawSummaryText'}>
						{t('withdrawSummaryMain')}
					</h1>
				</div>
			</div>
		</>
	);
};

export default WithdrawSummaryLayout;
